import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import '../../styleLess/signature/activity.scss'
import lang from 'lang/en'
import { getProjectById } from 'api/Project/project'
import { useParams } from 'react-router-dom'
import { getCookie } from 'helper/cookie'
import {
  RightOutlined,
  CalendarOutlined,
  InboxOutlined,
  ClockCircleFilled,
} from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import { Timeline } from 'antd'
import { getProjectLog } from 'api/ActivityLog/projectlog'
import moment from 'moment'
import { toLower } from 'lodash'
const ActivityContainer = styled.div``
const HeadContainer = styled.div``
const BodyContainer = styled.div``
const CardStatus = styled.div``
const CardReason = styled.div``
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`
const initalState = {
  data: [],
  isLoading: true,
}
const activity = () => {
  const token = getCookie('access_token_admin')
  const language = getCookie('lang')
  const word = lang[language]
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  const [dataProject, setDataProject] = useState(initalState.data)
  const [dataLog, setDataLog] = useState(initalState.data)
  const history = useHistory()
  const { id } = useParams()

  const getDataProject = async () => {
    await getProjectById({
      id: id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataProject([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataProject(data)
          setIsLoading(false)
        } else {
          setDataProject([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataProject([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getLogDataProject = async () => {
    await getProjectLog({
      project_id: id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataLog([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataLog(data)
          setIsLoading(false)
        } else {
          setDataLog([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataLog([])
        setIsLoading(false)
        console.error(error)
      })
  }

  useEffect(() => {
    if (token) {
      getDataProject()
      getLogDataProject()
    }
  }, [token])

  const goProjectList = () => {
    history.push({
      pathname: '/project-list',
    })
  }
  const colorStatus = (item) => {
    return item.status_id === 3
      ? 'project-type-waitingforapprove-register'
      : item.status_id === 4
      ? 'project-type-registered'
      : item.status_id === 5
      ? 'project-type-waitingforapprove-kickoff'
      : item.status_id === 6
      ? 'project-type-kickoff'
      : item.status_id === 7 || item.status_id === 27
      ? 'project-type-onhold'
      : item.status_id === 8
      ? 'project-type-waitingforapprove-complete'
      : item.status_id === 9
      ? 'project-type-complete'
      : [11, 12, 26].includes(item.status_id)
      ? 'project-type-cancelled'
      : item.status_id === 19
      ? 'project-type-cancelled'
      : item.status_id === 21
      ? 'project-type-completedwithdelay'
      : item.status_id === 28
      ? 'project-type-waitingforapprove-hold'
      : 'project-type-saved'
  }
  const content = () => {
    if (dataLog.length > 0) {
      return (
        <BodyContainer className="body-container">
          <TextTitleBold style={{ marginBottom: 32 }} >{word['Project_Activity']}</TextTitleBold>
          <Timeline>
            {dataLog.map((item) => {
              return (
                <Timeline.Item
                  dot={<div className={`dot-custom ${colorStatus(item)}`}></div>}
                >
                  <CardStatus className="card-status">
                    <div className={`tab-color ${colorStatus(item)}`}></div>
                    <div className="in-card">
                      <div className="left-in-card">
                        <img className="imageStyle" src={item.pic_display}></img>
                        <div className="left-in-card-responsive">
                          <h5 className="text-name">
                            {item.firstname} {item.lastname}
                          </h5>
                          <div className="width-status">
                            <div className={`Status  ${colorStatus(item)}`}>
                              <p className="font-status font-color-status">
                                {item.status_msg}
                              </p>
                            </div>
                          </div>
                          {[3, 5, 8, 28].includes(item.status_id) ? (
                            <h5 className="text-des">
                              {item.firstname} {word['has']} {word['requested_approval']}{' '}
                            </h5>
                          ) : (
                            <h5 className="text-des">
                              {item.firstname} {word['has']}{' '}
                              {item.event_msg.toLowerCase()} {word['project']}{' '}
                            </h5>
                          )}
                          <div className="responsive-date">
                            <CalendarOutlined className="calendarOutlined" />
                            <span className="small text-date">
                              {moment(item.created_at).format('DD/MM/YYYY')} -{' '}
                              {moment(item.created_at).format('LT')}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="right-in-card">
                        <CalendarOutlined className="calendarOutlined" />
                        <p className="text-date">
                          {moment(item.created_at).format('DD/MM/YYYY')} -{' '}
                          {moment(item.created_at).format('LT')}
                        </p>
                      </div>
                    </div>
                  </CardStatus>
                  <CardReason
                    hidden={item.message ? false : true}
                    className="card-reason"
                  >
                    <p className="reason">{word['reason']}</p>
                    <p className="text-reason">{item.message}</p>
                  </CardReason>
                </Timeline.Item>
              )
            })}
          </Timeline>
        </BodyContainer>
      )
    } else {
      return (
        <BodyContainer className="body-container">
          <TextTitleBold style={{ marginBottom: 32 }}>{word['Project_Activity']}</TextTitleBold>
          <div className="empty-container">
            <InboxOutlined className="InboxOutlined" />
            <h1>{word['no_data']}</h1>
          </div>
        </BodyContainer>
      )
    }
  }
  return (
    <ActivityContainer className="activity-container">
      <HeadContainer className="header-container">
        <div className="BreadCrumb" style={{ marginBottom: 8 }}>
          <h4 className="level1" onClick={goProjectList}>
            {word['Project']}
          </h4>
          <RightOutlined className="icon-style" />
          <h4 className="level2">{word['Project_Activity']}</h4>
        </div>
        <div>
          <TextTitleBold className="text-header clutter">
            {id} - {dataProject.name}
          </TextTitleBold>
        </div>
      </HeadContainer>
      {content()}
    </ActivityContainer>
  )
}
export default activity
